import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'PRICING_CHANGE';
let price = 0.0;
let requestState = {
    pending: false,
    complete: false,
    success: false,
    fail: false,
    error: null,
};
const PricingStore = assign({}, EventEmitter.prototype, {
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getRequestState() {
        return Object.assign({}, requestState);
    },
    getPrice() {
        return price;
    },
    setRequestPending() {
        requestState = {
            pending: false,
            complete: true,
            success: true,
            fail: false,
            error: null,
        };
    },
    setPricingError(err) {
        requestState = {
            pending: false,
            complete: true,
            success: false,
            fail: true,
            error: err,
        };
    },
    setPrice(p) {
        price = p;
        requestState = {
            pending: false,
            complete: true,
            success: true,
            fail: false,
            error: null,
        };
    },
});
PricingStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.GET_PRICE_REQUEST:
            PricingStore.setRequestPending();
            PricingStore.emitChange();
            break;
        case ActionTypes.GET_PRICE_FAIL:
            PricingStore.setPricingError(action.data.err);
            PricingStore.emitChange();
            break;
        case ActionTypes.RECEIVE_PRICE:
            PricingStore.setPrice(action.price);
            PricingStore.emitChange();
            break;
        default:
    }
});
export default PricingStore;
